// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { bindActionCreators } from 'redux';
import Theme from './statsRadioPlayer/Theme';
import Banner from './statsRadioPlayer/Banner';
import StationInformation from './statsRadioPlayer/StationInformation';
import RecentlyPlayed from './statsRadioPlayer/RecentlyPlayed';
import type { StatsRadioPlayerData } from '../../domain/PlayerConfiguration';
import { saveStatsRadioPlayer } from '../../actions/radioConfigurationActions';

type Props = {
  actions: {
    saveStatsRadioPlayer: (data: StatsRadioPlayerData) => mixed;
  };
  data: StatsRadioPlayerData;
}

type State = {
  data: StatsRadioPlayerData;
}

class StatsRadioPlayerConfiguration extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      data: props.data,
    };
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (prevState.data !== this.state.data) {
      this.props.actions.saveStatsRadioPlayer(this.state.data);
    }
  }

  onSubmit = (e: Event) => {
    e.preventDefault();
  }

  onHeaderBackgroundColorChanged(hexColor) {
    this.setState({
      data: {
        ...this.state.data,
        theme: {
          ...this.state.data.theme,
          header: {
            ...this.state.data.theme.header,
            backgroundColor: hexColor,
          },
          stationInformation: {
            ...this.state.data.theme.stationInformation,
            backgroundColor: hexColor,
          },
        },
      },
    });
  }

  onThemeChanged(key, value: Object) {
    this.setState({
      data: {
        ...this.state.data,
        theme: {
          ...this.state.data.theme,
          [key]: value,
        },
      },
    });
  }

  onStationInformationChanged(key, value) {
    this.setState({
      data: {
        ...this.state.data,
        stationInformation: {
          ...this.state.data.stationInformation,
          [key]: value,
        },
      },
    });
  }

  onRecentlyPlayedSongsChanged(key, value) {
    if (key === 'nowPlayingSong') {
      this.setState({
        data: {
          ...this.state.data,
          nowPlayingSong: {
            display: value,
          },
        },
      });
    } else {
      this.setState({
        data: {
          ...this.state.data,
          recentlyPlayedSongs: {
            ...this.state.data.recentlyPlayedSongs,
            [key]: value,
          },
        },
      });
    }
  }

  onBannerChanged(bannerFile, hideBanner) {
    const theme = {
      ...this.state.data.theme,
      backgroundImage: bannerFile,
      hideBanner: hideBanner,
    };

    this.setState({
      data: {
        ...this.state.data,
        theme: theme,
      },
    });
  }

  render() {
    const { data } = this.state;

    return (
      <form onSubmit={this.onSubmit}>
        <Theme
          data={data}
          onValueChange={(key, value) => this.onStationInformationChanged(key, value)}
          onThemeChange={(key, value) => this.onThemeChanged(key, value)}
          onBackgroundColorChange={color => this.onHeaderBackgroundColorChanged(color)}
        />
        <Banner
          onBannerChanged={(banner, hide) => this.onBannerChanged(banner, hide)}
          data={data.theme}
        />
        <StationInformation
          data={data.stationInformation}
          demoTheme={data.theme}
          onValueChange={(key, value) => this.onStationInformationChanged(key, value)}
          onThemeChange={value => this.onThemeChanged('stationInformation', value)}
        />
        <RecentlyPlayed
          data={data}
          onValueChange={(key, value) => this.onRecentlyPlayedSongsChanged(key, value)}
          onThemeChange={value => this.onThemeChanged('recentlyPlayedSongs', value)}
        />
      </form>
    );
  }
}

function mapDispatchToProps(dispatch: *) {
  return {
    actions: bindActionCreators({ saveStatsRadioPlayer }, dispatch),
  };
}

export default translate('radioConfiguration')(connect(null, mapDispatchToProps)(StatsRadioPlayerConfiguration));



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/components/playerConfigurationForm/StatsRadioPlayerConfiguration.js